import { render, staticRenderFns } from "./IconCorner.vue?vue&type=template&id=b85392ce&scoped=true&"
import script from "./IconCorner.vue?vue&type=script&lang=ts&"
export * from "./IconCorner.vue?vue&type=script&lang=ts&"
import style0 from "./IconCorner.vue?vue&type=style&index=0&id=b85392ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85392ce",
  null
  
)

export default component.exports